export default __webpack_public_path__ + "60804d4e370cc66a81b1bfd8d0194939.svg";